import { CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";

const PasswordResetModal = ({ email, onContinue }) => {
  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center animate-in slide-in-from-bottom-4 zoom-in-95 duration-300 border border-gray-50">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary/10">
          <CheckCircle className="w-8 h-8 text-primary" strokeWidth={2} />
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-3">
          Reset Link Sent
        </h2>

        <p className="text-gray-600 mb-8 leading-relaxed">
          We've sent a password reset link to{" "}
          <span className="font-medium text-gray-900">{email}</span>.
          <br />
          Please check your inbox and follow the instructions.
        </p>

        <Button
          onClick={onContinue}
          className="w-full h-12 text-base font-medium rounded-xl bg-primary hover:bg-primary/90 text-white transition-all duration-200 hover:scale-[0.98] active:scale-[0.96] focus:ring-2 focus:ring-primary/20 focus:ring-offset-2"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default PasswordResetModal;
